import { createTheme, PaletteOptions } from '@mui/material/styles'

import palette from './palette'
import typography, { fontSizes, fontFamilies } from './typography'
import breakpoints from './breakpoints'
import components from './components'
import { transitions } from './animations'
import { radii, spacing } from './shapings'

const theme = createTheme({
  palette: palette as PaletteOptions,
  fontSizes,
  fontFamilies,
  typography,
  radii,
  spacing,
  space: spacing,
  shape: {
    borderRadius: radii.default,
  },
  transitions,
  breakpoints,
  components,
})

export type MyThemeType = typeof theme
export default theme
